// extracted by mini-css-extract-plugin
export default {"component":"AddEmployeeViaOfficeModal_component__5kLGT","modalContainer":"AddEmployeeViaOfficeModal_modalContainer__biQ7a"};